import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import BaseInput from './base';

export const passwordRegex = new RegExp(
  /^(?=(?:[^A-Za-z]*[A-Za-z]){1})(?=(?:[^0-9!@#$%^&*()_+-=]*[0-9!@#$%^&*()_+-=]){1}).*$/
);

const Password = props => (
  <BaseInput
    label="Enter your password"
    type="password"
    autoComplete="off"
    maxLength={50}
    name="password"
    data-cv-test="password"
    validate={val =>
      string()
        .required('Enter your password')
        .min(8, 'Password must be at least 8 characters')
        .max(128, 'Password has to be shorter than 128 characters!')
        .matches(
          /^(?=(?:[^A-Za-z]*[A-Za-z]){1})(?=(?:[^0-9!@#$%^&*()_+-=]*[0-9!@#$%^&*()_+-=]){1}).*$/,
          'Password must contain a letter AND a number or special character'
        )
        .validate(val)
        .then(() => null)
        .catch(err => err.errors.join(', '))
    }
    {...props}
  />
);

Password.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string
};

Password.defaultProps = {
  value: '',
  error: ''
};

export default Password;
